import { Navigate } from 'react-router-dom';
import React from 'react';
import useAuth from '../hooks/useAuth';

function PublicAccessOnly({ children }: { children: JSX.Element }) {
  const { authenticated } = useAuth();

  if (authenticated) {
    return <Navigate to="/eleicoes" />;
  }

  return children;
}

export default PublicAccessOnly;
